import {
  LayoutDashboard,
  CalendarDays,
  Bike,
  BarChart3,
  Sparkles,
  Settings,
  Shield,
} from "lucide-react";

/** Primary navigation — only routes that exist today. */
export const NAV_GROUPS = [
  {
    id: "overview",
    label: "Overview",
    items: [
      {
        to: "/",
        label: "Dashboard",
        mobileLabel: "Dashboard",
        icon: LayoutDashboard,
        testId: "nav-activities",
        end: true,
      },
    ],
  },
  {
    id: "training",
    label: "Training",
    items: [
      {
        to: "/calendar",
        label: "Calendar",
        mobileLabel: "Calendar",
        icon: CalendarDays,
        testId: "nav-calendar",
      },
      {
        to: "/workouts",
        label: "Workouts",
        mobileLabel: "Workouts",
        icon: Bike,
        testId: "nav-workouts",
      },
    ],
  },
  {
    id: "insights",
    label: "Insights",
    items: [
      {
        to: "/progress",
        label: "Progress",
        mobileLabel: "Progress",
        icon: BarChart3,
        testId: "nav-progress",
      },
    ],
  },
  {
    id: "coach",
    label: "Coach",
    items: [
      {
        to: "/coach",
        label: "AI Coach",
        mobileLabel: "Coach",
        icon: Sparkles,
        testId: "nav-coach",
      },
    ],
  },
];

export const ACCOUNT_NAV = {
  to: "/settings",
  label: "Settings",
  mobileLabel: "Settings",
  icon: Settings,
  testId: "nav-settings",
};

export const ADMIN_NAV = {
  to: "/admin",
  label: "Admin",
  mobileLabel: "Admin",
  icon: Shield,
  testId: "nav-admin",
};

/** Public links, plus Admin only when the signed-in profile says is_admin. */
export const navItemsForUser = (user) => {
  const items = [...flattenNavItems(), ACCOUNT_NAV];
  if (user?.is_admin === true) items.push(ADMIN_NAV);
  return items;
};

/** Reserved for later phases — not rendered as links. */
export const STAGED_NAV_ITEMS = [
  { id: "training-summary", label: "Training Summary", group: "insights" },
  { id: "performance", label: "Performance", group: "insights" },
  { id: "profiles-zones", label: "Profiles & Zones", group: "insights" },
  { id: "recovery", label: "Recovery", group: "insights" },
  { id: "roadmap", label: "Roadmap", group: "training" },
  { id: "plan-builder", label: "Plan Builder", group: "training" },
  { id: "devices", label: "Devices & Integrations", group: "account" },
];

export const flattenNavItems = () =>
  NAV_GROUPS.flatMap((group) => group.items);
